export { useExtendedRouter } from './useExtendedRouter';
export { useExtendedSearchParams } from './useExtendedSearchParams';

// Re-export the Next hooks, maybe we'll wrap them in the future,
// so it's easier to change them in one place.
export {
  useRouter, usePathname, useSearchParams, useParams,
} from 'next/navigation';
